<template>
  <article>
    <div :class="$style.root">
      <div :class="$style.wrapper">
        <h2 :class="$style.heading">
          {{ project.current.name }}
        </h2>

        <div :class="$style.progress">
          <div :class="$style.line">
            <div
              v-for="(stage, index) in stages"
              :class="[$style.point,
                       {[$style.red]: stage.value !== activeTab},
                       {[$style.blue]: stage.value === activeTab}
              ]"
              :key="index"
            >
              <div :class="$style.mark">
                <svg-icon
                  id="tick"
                  :class="$style.icon"
                />
              </div>
              <div :class="$style.btn">
                <button
                  :aria-label="stage.name"
                  :class="$style.button"
                  @click="setActiveTab(stage.value)"
                >{{ stage.name }}</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="project.current.description">
          <p
            v-if="activeTab === 'issue'"
            :class="$style.description"
            v-html="project.current.description.issue.join('<br><br>')"/>
          <p
            v-if="activeTab === 'process'"
            :class="$style.description"
            v-html="project.current.description.process.join('<br><br>')"/>
          <p
            v-if="activeTab === 'result'"
            :class="$style.description"
            v-html="project.current.description.result.join('<br><br>')"/>
        </div>
      </div>
    </div>

    <div :class="$style.galleryWrapper">
      <ProjectSlider :slider-content="project.current.images"/>

      <template v-if="project.current.videos">
        <video
          v-for="video in project.current.videos"
          ref="video"
          :key="video.id"
          :class="$style.video"
          :poster="video.poster"
          controls="controls"
        >
          <source
            v-for="source in video.sources"
            :key="source.src"
            :src="source.src"
            :type="source.type">
        </video>
      </template>
    </div>
  </article>
</template>
<script>
import { mapGetters } from 'vuex';
import { GET_PROJECT } from 'store/getters';
import SvgIcon from 'components/SVGIcon';
import ProjectSlider from 'components/ProjectSlider';

export default {
  beforeRouteLeave(to, from, next) {
    const video = this.$refs.video;
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.src = '';
      video.load();
    }
    next();
  },
  name: 'ProjectDescription',
  components: {
    SvgIcon,
    ProjectSlider,
  },
  props: {
    activeTab: {
      type: String,
      default: 'issue',
    },
  },
  data() {
    return {
      stages: [
        {
          name: 'Задача',
          value: 'issue',
        },
        {
          name: 'Процесс',
          value: 'process',
        },
        {
          name: 'Результат',
          value: 'result',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      project: GET_PROJECT,
    }),
  },
  methods: {
    setActiveTab(tab) {
      this.$emit('click', tab);
    },
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/helpers';

%descriptionContainer {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.root {
  @extend %container;
  @extend %section;

  &::after {
    display: none;
  }
}

.wrapper {
  @extend %content;
}

.galleryWrapper {
  @extend %content;
  max-width: 1280px;
}

.heading {
  @extend %heading;
}

.imgWrapper {
  margin: 17px 0;
}

.img {
  width: 100%;
  min-height: 235px;
  object-fit: cover;
}

.progress {
  @extend %descriptionContainer;
  padding: 40px 70px 65px;
  margin-bottom: 55px;

  @include media('<tablet') {
    margin-bottom: 0;
    padding: 40px 54px 65px;
  }
}

.line {
  width: 100%;
  height: 2px;
  background-color: $gray-7;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.point {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  z-index: $zidx-main;
}

.point.red {
  background-color: $red-light;
}

.point.blue {
  background-color: $blue;
}

%position {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
}

.mark {
  @extend %position;
  bottom: 20px;
}

.icon {
  min-width: 36px;
  height: 36px;
  transition: fill 0.4s;
}

.point.red .icon {
  fill: $red-light;
}

.point.blue .icon {
  fill: $blue;
}

.btn {
  @extend %position;
  top: 20px;
}

.button {
  @extend %button;
  min-width: 140px;

  @include media('<tablet') {
    padding: 5px;
    min-width: 82px;
  }
}

.point.red .button {
  @extend %buttonWhite;

  color: $red-light;
  border: 2px solid $red-light;
  text-align: center;
  border-radius: 70px;
}

.point.blue .button {
  color: $white;
  background-color: $blue;
  border: 2px solid $blue;
  text-align: center;
  border-radius: 70px;
}

.description {
  @extend %descriptionContainer;
  opacity: 0.8;
  color: $gray-dark;
  font-size: 16px;
  line-height: 25px;
  text-indent: 40px;
  text-align: justify;

  @include media('<tablet') {
    padding: 0 20px;
  }

  &::first-letter {
    margin-left: 20px;
  }
}

.description a {
  color: $red;
  text-decoration: none;
  transition: all 0.3s;
  border-bottom: 1px solid transparent;

  &:hover {
    border-color: $red;
  }
}

// Projects video
.video {
  width: 100%;
  max-height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectDescription.vue